const isAssetRequest = (url) => /^\/assets\/.*\/?/.test(url);

/**
 * This factory creates an interceptor that catches http requests whose
 * path starts with `/assets/...` and change it to `<basePath>/assets/...`
 * to let them be loaded in the apps with different base paths.
 *
 * @param {HTTPConfig} httpConfig - initial http config
 * @returns {HTTPConfig} - updated http config
 */
export const assetRequestInterceptorFactory = (basePath) =>
  (httpConfig) => {
    const { url } = httpConfig;

    if (!isAssetRequest(url)) {
      return httpConfig;
    }

    return {
      ...httpConfig,
      url: `${basePath}${url}`,
    };
  };
